<template>
  <div class="divContainer">
    <div v-if="loading" v-loading="loading" class="fullContainer"></div>
    <div v-else class="container">
      <main class="main">
        <el-form label-position="top" size="small" :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-card class="card">
                <div slot="header">
                  <strong style="font-size: 14px">壁纸基本信息</strong>
                </div>
                <div>
                  <el-form-item label="壁纸名称" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入壁纸名称" style="width: 300px"></el-input>
                  </el-form-item>

                  <el-form-item label="壁纸类型" prop="type">
                    <el-select v-model="ruleForm.type" placeholder="请选择壁纸类型" style="width: 300px" disabled>
                      <el-option v-for="item in wallpaperTypeOptions" :key="item" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="设计师" prop="designer">
                    <el-select v-model="ruleForm.designer" placeholder="请选择设计师" style="width: 300px" filterable
                      clearable>
                      <el-option v-for="item in designerOptions" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="资源预览">
                    <el-switch v-model="resourceShow" active-text="资源预览" inactive-text="资源不预览">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="Shader（交互壁纸资源：需要上传Shader后再上传文件）">
                    <div style="display: flex">
                      <el-button icon="el-icon-upload" @click="changeShander">
                        Shader</el-button>
                      <el-tooltip class="item" effect="dark" :content="shader" placement="top">
                        <div class="shaderTitle">{{ shader }}</div>
                      </el-tooltip>
                    </div>
                  </el-form-item>
                  <el-form-item label="资源包（支持扩展名：.zip .jpg .png .mp4）（壁纸合集等比较大的文件在这单个上传）" prop="backgroundUrl">
                    <el-upload class="upload-demo" action="" :http-request="customRequest" :show-file-list="false">
                      <el-button size="small" plain icon="el-icon-upload" :loading="uploadLoading">
                        上传文件</el-button>
                      <span style="color: #c0c4cc; margin-left: 10px">{{
                        this.ruleForm.backgroundName
                        }}</span>
                    </el-upload>
                  </el-form-item>
                  <el-form-item v-if="isCreate" label="模版批量上传" prop="backgroundUrl">
                    <el-button size="small" plain icon="el-icon-upload" @click="changeFileStatus">
                      批量上传文件</el-button>
                  </el-form-item>
                </div>
              </el-card>
              <el-card class="card">
                <div slot="header">
                  <strong style="font-size: 14px">关联解锁组</strong>
                </div>
                <div>
                  <el-form-item label="默认解锁组" prop="defaultUnlockType">
                    <el-select v-model="ruleForm.defaultUnlockType" placeholder="请选择默认解锁组" filterable clearable>
                      <el-option v-for="item in defaultUnlockOptions" :key="item.id" :label="item.groupName"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="数据集解锁组(选填)">
                    <div v-for="(item, index) in ruleForm.data_unlock_type_list" :key="index"
                      style="display: flex; margin-bottom: 5px">
                      <el-select v-model="item.lockGroupId" placeholder="请选择解锁组" filterable clearable>
                        <el-option v-for="item in defaultUnlockOptions" :key="item.id" :label="item.groupName"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <!--  @change="selectChange(index, item.dataSetId)" -->
                      <el-select v-model="item.dataSetId" placeholder="请选择数据集" style="margin: 0 10px" filterable
                        clearable>
                        <el-option v-for="item in deleteDataOption(dataOptions)" :key="item.id" :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <div style="line-height: 39px; margin-right: 10px"
                        v-show="ruleForm.data_unlock_type_list.length > 1" @click="deleteUnlockType(index)">
                        <i class="el-icon-error deleteIcon"></i>
                      </div>
                      <div style="line-height: 39px" @click="addUnlockType" v-show="ruleForm.data_unlock_type_list.length - 1 === index
                        ">
                        <i class="el-icon-circle-plus addIcon"></i>
                      </div>
                    </div>
                  </el-form-item>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card>
                <div slot="header">
                  <strong style="font-size: 14px; cursor: pointer" :class="dataResouceFlag ? 'dataActive' : ''"
                    @click="changeDataResouce(true)">预览</strong>
                  <strong style="margin: 0 10px">/</strong>
                  <strong style="font-size: 14px; cursor: pointer" :class="dataResouceFlag ? '' : 'dataActive'"
                    @click="changeDataResouce(false)">预览webp</strong>
                </div>
                <div class="reviewDiv">
                  <div class="contentImg">
                    <div v-if="
                      ruleForm.backgroundUrl && websockDataKey === 'video'
                    " class="updateContainer" @mouseenter="maskFlag = true" @mouseleave="mouseleftFun">
                      <video autoplay style="max-width: 80%; max-height: 80%" :src="ruleForm.backgroundUrl" controls
                        muted></video>

                      <div class="updateMask" v-show="maskFlag && !isCreate">
                        <label for="uploadID_face" id="show_info_face" class="updateButton">
                          <div class="updateFont">
                            <i :class="uploadLoading || updateLoading
                                ? 'el-icon-loading'
                                : 'el-icon-upload'
                              "></i>
                            {{ uploadLoading ? "上传中" : "更 新" }}
                          </div>
                        </label>
                        <input class="hide" @change="updateImg(websockDataKey)" type="file" id="uploadID_face" />
                      </div>
                    </div>
                    <div v-else-if="
                      this.ruleForm.backgroundUrl &&
                      this.websockDataKey === 'animation'
                    ">
                      <lottie :options="options"> </lottie>
                    </div>
                    <div v-else-if="this.ruleForm.backgroundUrl" class="updateContainer" @mouseenter="maskFlag = true"
                      @mouseleave="mouseleftFun">
                      <img v-lazy="ruleForm.backgroundUrl" alt="预览图" :key="websockDataKey" :style="websockDataKey === 'microThumbShow'
                          ? 'width:27px'
                          : ''
                        " />

                      <div class="updateMask" v-show="maskFlag && !isCreate">
                        <label for="uploadID_face" id="show_info_face" class="updateButton">
                          <div class="updateFont">
                            <i :class="uploadLoading || updateLoading
                                ? 'el-icon-loading'
                                : 'el-icon-upload'
                              "></i>
                            {{ uploadLoading ? "上传中" : "更 新" }}
                          </div>
                        </label>
                        <input class="hide" @change="updateImg(websockDataKey)" type="file" id="uploadID_face" />
                      </div>
                    </div>

                    <el-empty description="预览页面为空" :image-size="200" v-else></el-empty>
                  </div>
                  <div v-if="
                    ruleForm.type === '静态壁纸资源' ||
                    ruleForm.type === '联系人海报资源' ||
                    ruleForm.type === 'TV屏保'
                  ">
                    <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                      <el-tab-pane :label="item.name" v-for="(item, index) in websockData" :key="index"
                        :name="item.name">
                        <div v-if="!item.staticImage">
                          <el-tag :type="ruleForm.backgroundUrl ===
                              item['content']['imageUrl']
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(
                                item['content']['imageUrl'],
                                'imageUrl'
                              )
                              ">主静态图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.thumbUrl
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.thumbUrl, 'thumbUrl')">缩略图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.microThumbShow
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(
                                item.microThumbShow,
                                'microThumbShow'
                              )
                              ">微缩图</el-tag>
                        </div>
                        <div v-else>
                          <el-tag :type="ruleForm.backgroundUrl === item.staticImage
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.staticImage, 'imageUrl')">预览图</el-tag>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else-if="ruleForm.type === '视频壁纸资源'">
                    <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                      <el-tab-pane :label="item.name" v-for="(item, index) in websockData" :key="index"
                        :name="item.name">
                        <div v-if="!item.staticImage" class="tagContainer">
                          <el-tag :type="ruleForm.backgroundUrl === item.content.imageUrl
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(item.content.imageUrl, 'imageUrl')
                              ">主静态图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.thumbUrl
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.thumbUrl, 'thumbUrl')">缩略图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.microThumbShow
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(
                                item.microThumbShow,
                                'microThumbShow'
                              )
                              ">微缩图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.content.videoUrl
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(item.content.videoUrl, 'video')
                              ">视频资源</el-tag>
                        </div>
                        <div v-else>
                          <el-tag :type="ruleForm.backgroundUrl === item.staticImage
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.staticImage, 'imageUrl')">预览图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.videoImage
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.videoImage, 'video')">视频资源</el-tag>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else-if="ruleForm.type === '4D Parallax壁纸资源'">
                    <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                      <el-tab-pane :label="item.name" v-for="(item, index) in websockData" :key="index"
                        :name="item.name">
                        <div v-if="!item.staticImage" class="tagContainer">
                          <el-tag :type="ruleForm.backgroundUrl === item.content.imageUrl
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(item.content.imageUrl, 'imageUrl')
                              ">主静态图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.thumbUrl
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.thumbUrl, 'thumbUrl')">缩略图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.microThumbShow
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(
                                item.microThumbShow,
                                'microThumbShow'
                              )
                              ">微缩图</el-tag>
                          <el-tag v-for="(val, index) in item.content.parallaxImage
                            .layers" :key="val.index" :type="ruleForm.backgroundUrl === val.url
                                  ? 'success'
                                  : 'info'
                                " @click="setContentImg(val.url, 'layer4D', index)">layer{{ index + 1 }}</el-tag>
                        </div>
                        <div v-else class="tagContainer">
                          <el-tag :type="ruleForm.backgroundUrl === item.staticImage
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.staticImage, 'imageUrl')">预览图</el-tag>
                          <el-tag v-for="(val, index) in item.layers" :key="val" :type="ruleForm.backgroundUrl === val
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(val, 'layer4D', index)">layer{{ index + 1 }}</el-tag>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else-if="ruleForm.type === '重力壁纸资源'">
                    <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                      <el-tab-pane :label="item.name" v-for="(item, index) in websockData" :key="index"
                        :name="item.name">
                        <div v-if="!item.staticImage" class="tagContainer">
                          <el-tag :type="ruleForm.backgroundUrl === item.content.imageUrl
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(item.content.imageUrl, 'imageUrl')
                              ">主静态图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.thumbUrl
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.thumbUrl, 'thumbUrl')">缩略图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.microThumbShow
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(
                                item.microThumbShow,
                                'microThumbShow'
                              )
                              ">微缩图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl ===
                              item.content.gravityImage.bgUrl
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(
                                item.content.gravityImage.bgUrl,
                                'backgroundImg'
                              )
                              ">背景图</el-tag>
                          <el-tag v-for="(val, index) in item.content.gravityImage
                            .elements" :key="val.url" :type="ruleForm.backgroundUrl === val.url
                                  ? 'success'
                                  : 'info'
                                " @click="setContentImg(val.url, 'element', index)">element{{ index + 1 }}</el-tag>
                        </div>
                        <div v-else class="tagContainer">
                          <el-tag :type="ruleForm.backgroundUrl === item.staticImage
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.staticImage, 'imageUrl')">预览图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.backgroundImage
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(
                                item.backgroundImage,
                                'backgroundImg'
                              )
                              ">背景图</el-tag>
                          <el-tag v-for="(val, index) in item.layers" :key="val" :type="ruleForm.backgroundUrl === val
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(val, 'element', index)">element{{ index + 1 }}</el-tag>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else-if="ruleForm.type === '动画壁纸资源'">
                    <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                      <el-tab-pane :label="item.name" v-for="(item, index) in websockData" :key="index"
                        :name="item.name">
                        <div v-if="!item.staticImage" class="tagContainer">
                          <el-tag :type="ruleForm.backgroundUrl === item.content.imageUrl
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(item.content.imageUrl, 'imageUrl')
                              ">主静态图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.thumbUrl
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.thumbUrl, 'thumbUrl')">缩略图</el-tag>

                          <el-tag :type="ruleForm.backgroundUrl === item.microThumbShow
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(
                                item.microThumbShow,
                                'microThumbShow'
                              )
                              ">微缩图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.wallpaper
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.wallpaper, 'animation')">动画</el-tag>

                          <el-tag v-for="(val, index) in item.images" :key="val" :type="ruleForm.backgroundUrl === val
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(val, 'images', index)">images{{ index + 1 }}</el-tag>
                        </div>
                        <div v-else class="tagContainer">
                          <el-tag :type="ruleForm.backgroundUrl === item.staticImage
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.staticImage, 'imageUrl')">预览图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.wallpaper
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.wallpaper, 'animation')">动画</el-tag>

                          <el-tag v-for="(val, index) in item.layers" :key="val" :type="ruleForm.backgroundUrl === val
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(val, 'images', index)">images{{ index + 1 }}</el-tag>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else-if="ruleForm.type === '壁纸合集资源'">
                    <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                      <el-tab-pane :label="item.name" v-for="(item, index) in websockData" :key="index"
                        :name="item.name">
                        <div v-if="!item.staticImage" class="tagContainer">
                          <el-tag :type="ruleForm.backgroundUrl === item.content.imageUrl
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(item.content.imageUrl, 'imageUrl')
                              ">主静态图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.thumbUrl
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.thumbUrl, 'thumbUrl')">缩略图</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl === item.microThumbShow
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(
                                item.microThumbShow,
                                'microThumbShow'
                              )
                              ">微缩图</el-tag>
                          <el-tag v-for="(val, index) in item.content.image_list" :key="val" :type="ruleForm.backgroundUrl === val
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(val, 'collect', index)">合集图片:{{ index + 1 }}</el-tag>
                        </div>
                        <div v-else class="tagContainer">
                          <el-tag :type="ruleForm.backgroundUrl === item.staticImage
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(item.staticImage, 'imageUrl')">预览图</el-tag>
                          <el-tag v-for="(val, index) in item.image_list" :key="val" :type="ruleForm.backgroundUrl === val
                              ? 'success'
                              : 'info'
                            " @click="setContentImg(val, 'collect', index)">合集图片:{{ index + 1 }}</el-tag>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else-if="ruleForm.type === 'OS26景深壁纸资源'">
                    <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                      <el-tab-pane :label="item.name" v-for="(item, index) in websockData" :key="index"
                        :name="item.name">
                        <div v-if="!item.staticImage" class="tagContainer">
                          <el-tag :type="ruleForm.backgroundUrl ===
                              item.content.wallpaperConfig.iphone_preview
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(
                                item.content.wallpaperConfig.iphone_preview,
                                'OS26景深壁纸资源'
                              )
                              ">iphone_preview</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl ===
                              item.content.wallpaperConfig.ipad_preview
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(
                                item.content.wallpaperConfig.ipad_preview,
                                'OS26景深壁纸资源'
                              )
                              ">ipad_preview</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl ===
                              item.content.wallpaperConfig.highlight
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(
                                item.content.wallpaperConfig.highlight,
                                'OS26景深壁纸资源'
                              )
                              ">highlight</el-tag>
                          <el-tag :type="ruleForm.backgroundUrl ===
                              item.content.wallpaperConfig.original
                              ? 'success'
                              : 'info'
                            " @click="
                              setContentImg(
                                item.content.wallpaperConfig.original,
                                'OS26景深壁纸资源'
                              )
                              ">original</el-tag>
                        </div>
                        <div v-else class="tagContainer">
                          <el-tag :type="ruleForm.backgroundUrl === item
                              ? 'success'
                              : 'info'
                            " v-for="item in item.image_list" @click="setContentImg(item, 'OS26景深壁纸资源')">{{
                              item.substring(item.lastIndexOf("_") + 1)
                            }}</el-tag>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div v-else>
                    <template v-if="!isCreate">
                      <el-tag style="margin-bottom: 10px" type="warning" v-for="item in websockData[websockData.length - 1]
                        .image_list" @click="downloadContent(item)">{{ item.substring(item.lastIndexOf("_") + 1)
                        }}</el-tag>
                    </template>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <classifyTag :dynamicTagsList.sync="ruleForm.dynamicTags" :type="1"></classifyTag>
          <tagCard :tagVOList.sync="ruleForm.tagVOList"></tagCard>

          <filter-resource-card :country="ruleForm.country" :appVersion="ruleForm.appVersion" :dataOptions="dataOptions"
            :androidBeginVersion.sync="ruleForm.androidBeginVersion"
            :androidOverVersion.sync="ruleForm.androidOverVersion"
            :androidNeglectVersion.sync="ruleForm.androidNeglectVersion"
            :iosBeginVersion.sync="ruleForm.iosBeginVersion" :iosOverVersion.sync="ruleForm.iosOverVersion"
            :iosNeglectVersion.sync="ruleForm.iosNeglectVersion"></filter-resource-card>
          <other-card :remarks.sync="ruleForm.comment"></other-card>
        </el-form>
      </main>
      <footer class="bottomContainer">
        <div>
          <el-button size="small" @click="goBack">取消</el-button>
          <el-button type="primary" size="small" @click="submitForm()" :loading="submitLoading"
            :disabled="submitLoading || updateLoading || resourceShowFlag">保存</el-button>
        </div>
      </footer>
      <uploadShader :name="ruleForm.name" :shader.sync="shader" :shaderFlag.sync="shaderFlag"></uploadShader>
      <batchUploadFileToS3 ref="batchUploadFileToS3" :batchUploadFileDialogVisible.sync="batchUploadFileDialogVisible">
      </batchUploadFileToS3>
    </div>
  </div>
</template>

<script>
import {
  getAllCategory,
  uploadZip,
  getAllDesignerOptionCreate,
  uploadFile,
} from "../../../api/comment";
import {
  getWallpaperById,
  updateWallpaper,
  addWallpaper,
  resourcesUpdate,
} from "../../../api/wallpaperManage";
import { getAllDataList } from "../../../api/classifyManage";
import { getLockGroupList } from "../../../api/unlockGroup";
import { VUE_APP_WSR_URL } from "../../../utils/varAble.js";
import { getAllTag } from "../../../api/tagManage";
import index from "../../../components/lottie/index.vue";
import tagCard from "../../../components/tagCard.vue";
import classifyTag from "../../../components/classifyTag.vue";
import uploadShader from "../../../components/uploadShader.vue";
import filterResourceCard from "../../../components/filterResourceCard.vue";
import otherCard from "../../../components/otherCard.vue";
import batchUploadFileToS3 from "../../../components/batchUploadFileToS3.vue";
import { resolveLayoutBackTo } from "../../../utils/layoutNavigation";
export default {
  name: "createOrEdit",
  data() {
    return {
      resourceAddress: "",
      batchFile: "",
      websock: null,
      messageSocket: "",
      preMessage: "",
      ruleForm: {
        name: "",
        type: "",
        designer: "",
        country: {
          isExclude: true,
          countries: [],
        },
        androidBeginVersion: "",
        androidOverVersion: "",
        androidNeglectVersion: "",
        iosBeginVersion: "",
        iosOverVersion: "",
        iosNeglectVersion: "",
        appVersion: [
          {
            start: "",
            end: "",
            skip: "",
            dataSetId: "",
          },
        ],
        comment: "",
        backgroundUrl: "",
        backgroundName: "",
        id: "",
        defaultUnlockType: "",
        data_unlock_type_list: [
          {
            lockGroupId: "",
            dataSetId: "",
          },
        ],
        dynamicTags: [],
        tagVOList: [],
      },
      rules: {
        name: [
          { required: true, message: "壁纸名称不能为空", trigger: "blur" },
        ],
        designer: [
          { required: true, message: "设计师不能为空", trigger: "change" },
        ],
        defaultUnlockType: [
          {
            required: true,
            message: "默认解锁方式不能为空",
            trigger: "change",
          },
        ],
      },
      allClassifyList: [],
      searchClassify: "",
      searchTag: "",
      allTagList: [],
      isCreate: true,
      loading: false,
      uploadLoading: false,
      wallpaperTypeOptions: [
        "静态壁纸资源",
        "视频壁纸资源",
        "4D Parallax壁纸资源",
        "重力壁纸资源",
        "动画壁纸资源",
      ],
      designerOptions: [],
      dataOptions: [],
      defaultUnlockOptions: [],
      dialogVisible: false,
      dialogVisibleTag: false,
      tagMap: {},
      websockData: [],
      activeName: "",
      websockDataKey: "",
      optionFlag: false,
      maskFlag: false,
      websockDataIndex: "",
      uploadLoading: false,
      submitLoading: false,
      updateLoading: false,
      liveTime: "",
      showResource: "",
      resourceShow: false,
      resourceShowFlag: false,
      dataResouceFlag: true,
      wallpaperWebpUrlList: [],
      wallpaperUrlList: [],
      urlList: [],
      webpUrlList: [],
      options: {
        animationData: "",
        autoplay: true,
        loop: true,
      },
      searchTimer: null,
      shader: "",
      shaderFlag: false,
      batchUploadFlag: false,
      batchUploadFileDialogVisible: false,
    };
  },
  components: {
    lottie: index,
    tagCard,
    classifyTag,
    uploadShader,
    filterResourceCard,
    otherCard,
    batchUploadFileToS3,
  },
  computed: {
    getType() {
      return function (key) {
        let dict = new Map([
          [0, "静态壁纸资源"],
          ["静态壁纸资源", 0],
          [1, "视频壁纸资源"],
          ["视频壁纸资源", 1],
          [2, "4D Parallax壁纸资源"],
          ["4D Parallax壁纸资源", 2],
          [3, "重力壁纸资源"],
          ["重力壁纸资源", 3],
          [4, "动画壁纸资源"],
          ["动画壁纸资源", 4],
          [5, "壁纸合集资源"],
          ["壁纸合集资源", 5],
        ]);
        return dict.get(key);
      };
    },
  },
  watch: {
    updateLoading: function (newval, oldVal) {
      if (newval) {
        this.maskFlag = true;
      } else {
        this.maskFlag = false;
      }
    },
    uploadLoading: function (newval, oldVal) {
      if (newval) {
        this.maskFlag = true;
      } else {
        this.maskFlag = false;
      }
    },
  },
  created() {
    this.isCreate = this.$route.path.indexOf("edit") === -1;
    //获取所有的数据集
    this.getAllData();
    //获取所有的设计师
    this.getAllDesigner();
    //获取所有的解锁方式
    this.getAllUnlock();
    //获取所有的分类信息
    this.getCategoryInfo();
    this.getTagInfo();
    if (!this.isCreate) {
      //请求编辑信息
      this.getRuleForm();
    }
  },
  beforeDestroy() {
    //离开路由之后断开websocket连接
    try {
      clearInterval(this.liveTime);
      this.websock.close();
    } catch (error) { }
  },
  methods: {
    downloadContent(url) {
      let eleLink = document.createElement("a");
      eleLink.style.display = "none";
      // eleLink.download = fileName
      eleLink.href = url;
      eleLink.target = "_blank";
      // 受浏览器安全策略的因素，动态创建的元素必须添加到浏览器后才能实施点击
      document.body.appendChild(eleLink);
      // 触发点击
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },
    // 批量上传多个文件
    changeFileStatus() {
      (this.batchUploadFlag = true), (this.batchUploadFileDialogVisible = true);
    },
    getBatchFile(res, index) {
      this.batchUploadFlag = false;
      //创建
      var categoryIdList = this.ruleForm.dynamicTags.map((res) => {
        return this.tagMap[res];
      });
      var params = {
        wallpaperName: res.name,
        wallpaperUrlList: this.wallpaperUrlList,
        wallpaperWebpUrlList: this.wallpaperWebpUrlList,
        wallpaperType: this.ruleForm.type,
        categoryIdList: categoryIdList.join(","),
        defaultLockGroupId: this.ruleForm.defaultUnlockType,
        dataSetLockGroupList: this.setDataUnlockTypeList(
          this.ruleForm.data_unlock_type_list
        ),
        countryList: this.ruleForm.country,
        androidBeginVersion: this.ruleForm.androidBeginVersion,
        androidOverVersion: this.ruleForm.androidOverVersion,
        androidNeglectVersion: this.ruleForm.androidNeglectVersion.split(","),
        iosBeginVersion: this.ruleForm.iosBeginVersion,
        iosOverVersion: this.ruleForm.iosOverVersion,
        iosNeglectVersion: this.ruleForm.iosNeglectVersion.split(","),
        appVersionDataSetList: this.setAppVersion(this.ruleForm.appVersion),
        thumbUrl: "",
        comment: this.ruleForm.comment,
        authorId: this.ruleForm.designer,
        key: this.ruleForm.key,
        tagKeySet: this.ruleForm.tagVOList.map((e) => {
          return e.key;
        }),
        shader: this.shader,
      };
      if (this.websockData[0]) {
        params["thumbUrl"] = this.websockData[0].content.imageUrl;
      }
      var file = new FormData();
      file.append("dataJson", JSON.stringify({ wallpaperCo: params }));
      file.append("resourceAddress", res.data);
      addWallpaper(file);
      if (index == this.$refs.batchUploadFileToS3.filesList.length - 1) {
        this.$message.success("新建成功");
        this.navigateAfterWallpaperSave();
      }
    },
    //切换Shander
    changeShander() {
      this.shaderFlag = true;
    },
    //websocket链接周期函数
    initWebSocket() {
      this.preMessage = JSON.parse(JSON.stringify(this.messageSocket));
      if (this.preMessage) {
        clearInterval(this.liveTime);
        this.websock.close();
        console.log("close");
      }
      this.messageSocket = Date.now();

      //初始化weosocket
      const wsuri =
        process.env.NODE_ENV === "development"
          ? `${VUE_APP_WSR_URL}backend-wallpaper-test.kika-backend.com/v1/api/messageSocket/{${this.messageSocket}}`
          : `${VUE_APP_WSR_URL}${window.location.host}/v1/api/messageSocket/{${this.messageSocket}}`;
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
      console.log("link websocket");
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      var actions = { message: "header live" };
      this.liveTime = setInterval(() => {
        this.websocketsend(JSON.stringify(actions));
      }, 30000);
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      const redata = JSON.parse(e.data) || "";
      if (redata.code == 200) {
        //数据接收
        this.websockData = redata.items;
        this.wallpaperUrlList = redata.items;
        this.wallpaperWebpUrlList = redata.items_webp;
        this.activeName = redata.items[0].name;
        this.ruleForm.backgroundUrl = redata.items[0].content.imageUrl;
        this.dataResouceFlag = true;
        this.ruleForm.type = this.getType(redata.resource_type);
      } else if (redata.code == 250) {
        var type = this.getType(redata.type);
        this.setUpdateUrl(
          redata.name,
          redata.key,
          type,
          redata.index,
          redata.url,
          redata.resourceType,
          redata.microThumbShow || ""
        );
        this.$notify({
          title: "成功",
          message: "资源更新成功",
          type: "success",
        });
        this.updateLoading = false;
        document.getElementById("uploadID_face").value = "";
      } else {
        this.$notify({
          title: "消息",
          message: redata.message,
          type: "info",
        });
      }
      this.resourceShowFlag = false;
      this.uploadLoading = false;
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
    },
    //提交表单
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.isCreate) {
            // 批量上传多个文件
            if (this.batchUploadFlag) {
              if (
                Object.keys(this.$refs.batchUploadFileToS3.process).length > 0
              ) {
                let flag = true;
                for (const [key, value] of Object.entries(
                  this.$refs.batchUploadFileToS3.process
                )) {
                  if (value.percentage != 100) {
                    flag = false;
                    break;
                  }
                }
                if (flag) {
                  this.$refs.batchUploadFileToS3.batchSave(this.getBatchFile);
                } else {
                  this.$message({
                    type: "info",
                    duration: 5000,
                    message: "文件还没上传完,请稍后再保存",
                    showClose: true,
                  });
                }
              }

              return;
            }
            //创建
            var categoryIdList = this.ruleForm.dynamicTags.map((res) => {
              return this.tagMap[res];
            });
            var params = {
              wallpaperName: this.ruleForm.name,
              wallpaperUrlList: this.wallpaperUrlList,
              wallpaperWebpUrlList: this.wallpaperWebpUrlList,
              wallpaperType: this.ruleForm.type,
              categoryIdList: categoryIdList.join(","),
              defaultLockGroupId: this.ruleForm.defaultUnlockType,
              dataSetLockGroupList: this.setDataUnlockTypeList(
                this.ruleForm.data_unlock_type_list
              ),
              countryList: this.ruleForm.country,
              androidBeginVersion: this.ruleForm.androidBeginVersion,
              androidOverVersion: this.ruleForm.androidOverVersion,
              androidNeglectVersion:
                this.ruleForm.androidNeglectVersion.split(","),
              iosBeginVersion: this.ruleForm.iosBeginVersion,
              iosOverVersion: this.ruleForm.iosOverVersion,
              iosNeglectVersion: this.ruleForm.iosNeglectVersion.split(","),
              appVersionDataSetList: this.setAppVersion(
                this.ruleForm.appVersion
              ),
              thumbUrl: "",
              comment: this.ruleForm.comment,
              authorId: this.ruleForm.designer,
              key: this.ruleForm.key,
              tagKeySet: this.ruleForm.tagVOList.map((e) => {
                return e.key;
              }),
              shader: this.shader,
            };
            if (this.websockData[0]) {
              params["thumbUrl"] = this.websockData[0].content.imageUrl;
            }
            var file = new FormData();
            file.append("dataJson", JSON.stringify({ wallpaperCo: params }));
            if (this.batchFile) {
              file.append("file", this.batchFile);
              addWallpaper(file);
              if (this.$route.path !== "/resource/wallpaper/list") {
                this.navigateAfterWallpaperSave();
              }
            } else if (this.wallpaperUrlList.length > 0) {
              file.append("resourceAddress", this.resourceAddress);
              addWallpaper(file);
              this.navigateAfterWallpaperSave();
            } else if (this.resourceAddress) {
              file.append("resourceAddress", this.resourceAddress);
              this.$notify({
                title: "提示",
                message: "资源上传中",
                type: "info",
              });
              addWallpaper(file);
              this.navigateAfterWallpaperSave();
            } else {
              this.$message({
                type: "info",
                message: "资源还没有上传～",
                showClose: true,
                duration: 5000,
              });
            }
          } else {
            //修改
            console.log("修改");
            var categoryIdList = this.ruleForm.dynamicTags.map((res) => {
              return this.tagMap[res];
            });
            var params = {
              id: this.$route.params.id,
              wallpaperName: this.ruleForm.name,
              wallpaperUrlList: this.wallpaperUrlList,
              wallpaperWebpUrlList: this.wallpaperWebpUrlList,
              urlList: this.urlList,
              webpUrlList: this.webpUrlList,
              wallpaperType: this.ruleForm.type,
              categoryIdList: categoryIdList.join(","),
              defaultLockGroupId: this.ruleForm.defaultUnlockType,
              dataSetLockGroupList: this.setDataUnlockTypeList(
                this.ruleForm.data_unlock_type_list
              ),
              countryList: this.ruleForm.country,
              androidBeginVersion: this.ruleForm.androidBeginVersion,
              androidOverVersion: this.ruleForm.androidOverVersion,
              androidNeglectVersion:
                this.ruleForm.androidNeglectVersion.split(","),
              iosBeginVersion: this.ruleForm.iosBeginVersion,
              iosOverVersion: this.ruleForm.iosOverVersion,
              iosNeglectVersion: this.ruleForm.iosNeglectVersion.split(","),
              appVersionDataSetList: this.setAppVersion(
                this.ruleForm.appVersion
              ),
              thumbUrl:
                this.websockData === "" || this.websockData.length === 0
                  ? ""
                  : this.websockData[0].content.imageUrl,
              comment: this.ruleForm.comment,
              authorId: this.ruleForm.designer,
              key: this.ruleForm.key,
              tagKeySet: this.ruleForm.tagVOList.map((e) => {
                return e.key;
              }),
              shader: this.shader,
            };
            var file = new FormData();
            file.append("dataJson", JSON.stringify({ wallpaperCo: params }));
            file.append("resourceAddress", this.resourceAddress);
            updateWallpaper(file).then((res) => {
              if (res.success) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                  showClose: true,
                  duration: 5000,
                });
              }
            });
            this.navigateAfterWallpaperSave();
          }
        } else {
          this.$message({
            type: "error",
            showClose: true,
            duration: 5000,
            message: "你还有参数没有填完整",
          });
          return false;
        }
      });
    },
    setDataUnlockTypeList(data) {
      var list = JSON.parse(JSON.stringify(data));
      for (let i = list.length - 1; i >= 0; i--) {
        if (!list[i].dataSetId || !list[i].lockGroupId) {
          list.splice(i, 1);
        }
      }
      return list;
    },
    setAppVersion(data) {
      var list = JSON.parse(JSON.stringify(data));
      for (let i = list.length - 1; i >= 0; i--) {
        list[i]["skip"] = list[i]["skip"].split(",");
        if (list[i].dataSetId != "0" && !list[i].dataSetId) {
          list.splice(i, 1);
        }
      }
      return list;
    },
    //请求编译信息
    getRuleForm() {
      this.loading = true;
      getWallpaperById({ id: this.$route.params.id })
        .then((res) => {
          if (res.success) {
            this.shader = res.data.shader;
            this.ruleForm.name = res.data.wallpaperName;
            this.ruleForm.key = res.data.key;
            this.ruleForm.type = res.data.wallpaperType;
            this.ruleForm.country = res.data.countryList;
            this.ruleForm.authorType = res.data.authorType;
            this.ruleForm.defaultUnlockType = res.data.defaultLockGroupId;
            this.ruleForm.designer = res.data.authorId;
            this.ruleForm.dynamicTags = this.getTagNames(res.data.categoryList);
            this.ruleForm.tagVOList = res.data.tagVOList;
            if (res.data.wallpaperLockGroupVOList.length > 0) {
              this.ruleForm.data_unlock_type_list =
                res.data.wallpaperLockGroupVOList;
            }
            if (res.data.wallpaperAppVersionList.length > 0) {
              this.ruleForm.appVersion = this.getAppVersion(
                res.data.wallpaperAppVersionList
              );
            }
            this.ruleForm.comment = res.data.comment;
            this.ruleForm.status = res.data.onOrOff;

            this.ruleForm.id = res.data.id;

            this.ruleForm.androidBeginVersion = res.data.androidBeginVersion;
            this.ruleForm.androidOverVersion = res.data.androidOverVersion;
            if (res.data.androidNeglectVersion) {
              this.ruleForm.androidNeglectVersion =
                res.data.androidNeglectVersion.join(",");
            }
            this.ruleForm.iosBeginVersion = res.data.iosBeginVersion;
            this.ruleForm.iosOverVersion = res.data.iosOverVersion;
            if (res.data.iosNeglectVersion) {
              this.ruleForm.iosNeglectVersion =
                res.data.iosNeglectVersion.join(",");
            }
            this.wallpaperWebpUrlList = res.data.wallpaperWebpUrlList;
            this.wallpaperUrlList = res.data.wallpaperUrlList;
            this.urlList = res.data.urlList;
            this.webpUrlList = res.data.webpUrlList;
            this.ruleForm.backgroundUrl =
              res.data.wallpaperUrlList[0].content.imageUrl;
            this.websockData = res.data.wallpaperUrlList;
            this.activeName =
              res.data.wallpaperUrlList.length === 0
                ? ""
                : res.data.wallpaperUrlList[0].name;
            this.websockDataKey = "imageUrl";
            this.optionFlag = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAppVersion(data) {
      data.forEach((element) => {
        element.skip = element.skip.join(",");
      });
      return data;
    },
    getTagNames(val) {
      let arr = [];
      val.forEach((element) => {
        arr.push(element.name);
      });
      return arr;
    },
    //获取图片的名称
    getFileName(name) {
      return name.substring(0, name.lastIndexOf("."));
    },
    //上传图片
    customRequest(params) {
      var str = params.file.name;
      if (!this.ruleForm.name) {
        this.ruleForm.name = this.getFileName(str);
      }
      var suffix = str.substring(str.lastIndexOf(".") + 1);
      const isZIP = suffix === "zip";
      const isJPG = suffix === "jpg";
      const isPNG = suffix === "png";
      const isMP4 = suffix === "mp4";

      if (isZIP || isJPG || isPNG || isMP4) {
        if (this.resourceShow) {
          //建立websocket链接
          this.initWebSocket();
          this.uploadLoading = true;
          this.resourceShowFlag = true;
          var file = new FormData();
          file.append("file", params.file);
          this.ruleForm.backgroundName = params.file.name;
          var fileName = params.file.name;
          fileName = fileName.substring(0, fileName.lastIndexOf("."));
          this.ruleForm.name = fileName;
          uploadZip(file, this.messageSocket);
          const formData = new FormData();
          formData.append('file', params.file);
          uploadFile(formData)
            .then((res) => {
              this.resourceAddress = res.data;
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
                duration: 5000,
                showClose: true,
              });
            });
        } else {
          this.uploadLoading = true;
          this.resourceShowFlag = true;
          const formData = new FormData();
          formData.append('file', params.file);
          uploadFile(formData)
            .then((res) => {
              this.resourceAddress = res.data;
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
                duration: 5000,
                showClose: true,
              });
            })
            .finally(() => {
              this.uploadLoading = false;
              this.resourceShowFlag = false;
            });
          var fileName = params.file.name;
          fileName = fileName.substring(0, fileName.lastIndexOf("."));
          this.ruleForm.name = fileName;
          this.ruleForm.backgroundName = params.file.name;
        }
      } else {
        this.$message({
          type: "error",
          message: "请按规定格式上传文件",
          showClose: true,
          duration: 5000,
        });
      }
      return false; //屏蔽了action的默认上传
    },
    //增加解锁方式的版本
    addUnlockType() {
      this.ruleForm.data_unlock_type_list.push({
        lockGroupId: "",
        dataSetId: "",
      });
    },
    //删除解锁方式的版本
    deleteUnlockType(index) {
      this.ruleForm.data_unlock_type_list.splice(index, 1);
    },
    //增加app的版本
    addAppVersion() {
      this.ruleForm.appVersion.push({
        start: "",
        end: "",
        skip: "",
        dataSetId: "",
      });
    },
    //删除app的版本
    deleteAppVersion(index) {
      this.ruleForm.appVersion.splice(index, 1);
    },
    //获取所有的数据集
    getAllData() {
      getAllDataList().then((res) => {
        if (res.success) {
          this.dataOptions = res.data;
        }
      });
    },
    //打开关联数据
    editLinkData() {
      this.dialogVisible = true;
    },
    //关闭tag
    handleClose(type, index) {
      // type 1为分类 2为tag
      if (type == 1) {
        this.ruleForm.dynamicTags.splice(index, 1);
      } else if (type == 2) {
        this.ruleForm.tagVOList.splice(index, 1);
      }
    },
    //搜索分类
    searchClassifyFun() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getCategoryInfo(this.searchClassify);
      }, 300);
    },
    //搜索tag
    searchTagFun() {
      this.getTagInfo(this.searchTag);
    },
    //获取所有的设计师
    getAllDesigner() {
      getAllDesignerOptionCreate().then((res) => {
        this.designerOptions = res.data;
      });
    },
    //获取搜有的解锁组方式
    getAllUnlock() {
      getLockGroupList(
        { pageNum: "", pageSize: "", groupName: "", lockGroupType: "" },
        0
      ).then((res) => {
        if (res.success) {
          this.defaultUnlockOptions = res.data;
        }
      });
    },
    //获取所有的分类信息
    getCategoryInfo(name = "") {
      getAllCategory(name).then((res) => {
        let tagMap = {};
        let arr = [];
        if (res.success) {
          res.data.forEach((element) => {
            arr.push(element.name);
            tagMap[element.name] = element.id;
          });
          if (JSON.stringify(this.tagMap) === "{}") {
            this.tagMap = tagMap;
          }

          this.allClassifyList = arr;
        }
      });
    },

    //获取所有tag
    getTagInfo(name = "") {
      getAllTag({ name }).then((res) => {
        if (res.success) {
          this.allTagList = res.data;
        }
      });
    },
    handleClick(tab, event) {
      if (!this.websockDataKey) {
        this.websockDataKey = "imageUrl";
      }
      this.websockData.forEach((e) => {
        if (e.name === this.activeName && e.staticImage) {
          if (this.websockDataKey === "layer4D") {
            this.ruleForm.backgroundUrl = e.layers[this.websockDataIndex];
          } else if (this.websockDataKey === "backgroundImg") {
            this.ruleForm.backgroundUrl = e.backgroundImage;
          } else if (this.websockDataKey === "video") {
            this.ruleForm.backgroundUrl = e.videoImage;
          } else if (this.websockDataKey === "element") {
            this.ruleForm.backgroundUrl = e.layers[this.websockDataIndex];
          } else if (this.websockDataKey === "images") {
            this.ruleForm.backgroundUrl = e.layers[this.websockDataIndex];
          } else if (this.websockDataKey === "animation") {
            this.ruleForm.backgroundUrl = e.wallpaper;
            this.options.animationData = e.wallpaper;
          } else if (this.websockDataKey === "collect") {
            this.ruleForm.backgroundUrl = e.image_list[this.websockDataIndex];
          } else {
            this.websockDataKey = "imageUrl";
            this.ruleForm.backgroundUrl = e.staticImage;
          }
        } else if (e.name === this.activeName && !e.staticImage) {
          if (this.websockDataKey === "imageUrl" && this.websockDataKey) {
            this.ruleForm.backgroundUrl = e.content.imageUrl;
          } else {
            if (this.websockDataKey === "layer4D") {
              this.ruleForm.backgroundUrl =
                e.content.parallaxImage.layers[this.websockDataIndex].url;
            } else if (this.websockDataKey === "backgroundImg") {
              this.ruleForm.backgroundUrl = e.content.gravityImage.bgUrl;
            } else if (this.websockDataKey === "video") {
              this.ruleForm.backgroundUrl = e.content.videoUrl;
            } else if (this.websockDataKey === "element") {
              this.ruleForm.backgroundUrl =
                e.content.gravityImage.elements[this.websockDataIndex].url;
            } else if (this.websockDataKey === "images") {
              this.ruleForm.backgroundUrl = e.images[this.websockDataIndex];
            } else if (this.websockDataKey === "animation") {
              this.ruleForm.backgroundUrl = e.wallpaper;
              this.options.animationData = e.wallpaper;
            } else if (this.websockDataKey === "collect") {
              this.ruleForm.backgroundUrl =
                e.content.image_list[this.websockDataIndex];
            } else if (this.websockDataKey === "OS26景深壁纸资源") {
              this.ruleForm.backgroundUrl =
                e.content.wallpaperConfig.iphone_preview;
            } else {
              this.ruleForm.backgroundUrl = e[this.websockDataKey];
            }
          }
        }
      });
    },
    //切换缩缩略图
    setContentImg(src, key, index) {
      this.websockDataKey = key;
      this.ruleForm.backgroundUrl = src;
      if (key === "layer4D") {
        this.websockDataIndex = index;
      } else if (key === "element") {
        this.websockDataIndex = index;
      } else if (key === "images") {
        this.websockDataIndex = index;
      } else if (key === "animation") {
        this.options.animationData = src;
      } else if (key === "collect") {
        this.websockDataIndex = index;
      }
    },

    goBack() {
      this.navigateAfterWallpaperSave();
    },
    /** 保存/取消后优先回到 query.backTo（如分类资源列表），否则壁纸列表。 */
    navigateAfterWallpaperSave() {
      const backTo = resolveLayoutBackTo(
        this.$route,
        "/resource/wallpaper/list"
      );
      if (backTo) {
        this.$router.push(backTo);
      } else {
        this.$router.push("/resource/wallpaper/list");
      }
    },
    //选择数据集的时候
    selectChange(index, value) {
      for (var i = 0; i < this.ruleForm.data_unlock_type_list.length; i++) {
        if (
          this.ruleForm.data_unlock_type_list[i].dataSetId == value &&
          i !== index
        ) {
          this.deleteUnlockType(index);
          this.$message({
            type: "info",
            message: "已选的数据集不能再次被选择",
            showClose: true,
            duration: 5000,
          });
          break;
        }
      }
    },
    //去除应用中的option
    deleteDataOption(val) {
      if (this.optionFlag) {
        this.$nextTick(() => {
          this.optionFlag = false;
        });
        return val;
      } else {
        var list = [];
        var arry = [];
        if (this.ruleForm.data_unlock_type_list)
          this.ruleForm.data_unlock_type_list.forEach((e) => {
            if (e.dataSetId !== "") {
              list.push(e.dataSetId);
            }
          });

        val.forEach((e) => {
          if (!list.includes(e.id)) {
            arry.push(e);
          }
        });
        return arry;
      }
    },
    //更新单独图
    updateImg() {
      this.initWebSocket();
      var file = new FormData();
      var realFile = document.getElementById("uploadID_face").files[0];
      file.append("file", realFile);
      var type = "";
      const resourcesType = JSON.parse(JSON.stringify(this.ruleForm.type));
      const name = JSON.parse(JSON.stringify(this.activeName));
      const url = JSON.parse(JSON.stringify(this.ruleForm.backgroundUrl));
      const key = JSON.parse(JSON.stringify(this.websockDataKey));
      const index = JSON.parse(JSON.stringify(this.websockDataIndex));
      if (this.ruleForm.type === "静态壁纸资源") {
        type = 0;
      } else if (this.ruleForm.type === "视频壁纸资源") {
        type = 1;
      } else if (this.ruleForm.type === "4D Parallax壁纸资源") {
        type = 2;
      } else if (this.ruleForm.type === "重力壁纸资源") {
        type = 3;
      } else if (this.ruleForm.type === "动画壁纸资源") {
        type = 4;
      } else if (this.ruleForm.type === "壁纸合集资源") {
        type = 5;
      }

      if (
        realFile.type.indexOf("jpg") !== -1 ||
        realFile.type.indexOf("jpeg") !== -1 ||
        realFile.type.indexOf("png") !== -1 ||
        realFile.type.indexOf("mp4") !== -1
      ) {
        this.updateLoading = true;
        setTimeout(() => {
          resourcesUpdate({
            file,
            name,
            url,
            key,
            type,
            userId: this.messageSocket,
            index,
            resourceType: this.dataResouceFlag,
          }).then((res) => {
            if (res.success) {
              this.$notify({
                title: "成功",
                message: "资源上传成功",
                type: "success",
              });

              this.$nextTick(() => {
                this.$notify.info({
                  title: "消息",
                  message: "资源正在处理中",
                });
              });
            }
          });
        }, 3000);
      } else {
        this.$message({
          type: "info",
          message: "上传的格式错误",
          showClose: true,
          duration: 5000,
        });
      }
    },
    //寻找更新图片插入的位置
    setUpdateUrl(name, key, type, contentIndex, url, resourceType, url1 = "") {
      if (type === "静态壁纸资源") {
        this.websockData.some((e, i) => {
          if (e.name === name) {
            var index = i;
            if (key === "imageUrl") {
              if (name === "原始资源") {
                this.websockData[index].staticImage = url;
                this.ruleForm.backgroundUrl = url;
              } else {
                this.websockData[index].content.imageUrl = url;
                this.ruleForm.backgroundUrl = url;
              }
            } else if (key === "thumbUrl") {
              this.websockData[index].thumbUrl = url;
              this.ruleForm.backgroundUrl = url;
            } else if (key === "microThumbShow") {
              if (url1) {
                this.websockData[index].microThumbShow = url1;
                this.websockData[index].microThumb = url;
                this.ruleForm.backgroundUrl = url1;
              } else {
                this.websockData[index].microThumb = url;
                this.ruleForm.backgroundUrl = url;
              }
            }
            return true;
          }
        });
      } else if (type === "视频壁纸资源") {
        this.websockData.some((e, i) => {
          if (e.name === name) {
            var index = i;
            if (key === "imageUrl") {
              if (name === "原始资源") {
                this.websockData[index].staticImage = url;
                this.ruleForm.backgroundUrl = url;
              } else {
                this.websockData[index].content.imageUrl = url;
                this.ruleForm.backgroundUrl = url;
              }
            } else if (key === "thumbUrl") {
              this.websockData[index].thumbUrl = url;
              this.ruleForm.backgroundUrl = url;
            } else if (key === "microThumbShow") {
              if (url1) {
                this.websockData[index].microThumbShow = url1;
                this.websockData[index].microThumb = url;
                this.ruleForm.backgroundUrl = url1;
              } else {
                this.websockData[index].microThumb = url;
                this.ruleForm.backgroundUrl = url;
              }
            } else if (key === "video") {
              if (name === "原始资源") {
                this.websockData[index].videoImage = url;
              } else {
                this.websockData[index].content.videoUrl = url;
              }

              this.ruleForm.backgroundUrl = url;
            }
            return true;
          }
        });
      } else if (type === "4D Parallax壁纸资源") {
        this.websockData.some((e, i) => {
          if (e.name === name) {
            var index = i;
            if (key === "imageUrl") {
              if (name === "原始资源") {
                this.websockData[index].staticImage = url;
                this.ruleForm.backgroundUrl = url;
                if (this.dataResouceFlag) {
                  this.urlList[index].staticImage = url;
                } else {
                  this.webpUrlList[index].staticImage = url;
                }
              } else {
                this.websockData[index].content.imageUrl = url;
                this.ruleForm.backgroundUrl = url;
                if (this.dataResouceFlag) {
                  this.urlList[index].content.imageUrl = url;
                } else {
                  this.webpUrlList[index].content.imageUrl = url;
                }
              }
            } else if (key === "thumbUrl") {
              this.websockData[index].thumbUrl = url;
              this.ruleForm.backgroundUrl = url;
              if (this.dataResouceFlag) {
                this.urlList[index].thumbUrl = url;
              } else {
                this.webpUrlList[index].thumbUrl = url;
              }
            } else if (key === "microThumbShow") {
              if (url1) {
                this.websockData[index].microThumbShow = url1;
                this.websockData[index].microThumb = url;
                this.ruleForm.backgroundUrl = url1;
                if (this.dataResouceFlag) {
                  this.urlList[index].microThumbShow = url;
                  this.urlList[index].microThumb = url;
                } else {
                  this.webpUrlList[index].microThumbShow = url;
                  this.webpUrlList[index].microThumb = url;
                }
              } else {
                this.websockData[index].microThumb = url;
                this.ruleForm.backgroundUrl = url;
                if (this.dataResouceFlag) {
                  this.urlList[index].microThumb = url;
                } else {
                  this.webpUrlList[index].microThumb = url;
                }
              }
            } else if (key === "layer4D") {
              if (e.staticImage) {
                this.websockData[index].layers[contentIndex] = url;
                this.ruleForm.backgroundUrl = url;
                if (this.dataResouceFlag) {
                  this.urlList[index].layers[contentIndex] = url;
                } else {
                  this.webpUrlList[index].layers[contentIndex] = url;
                }
              } else {
                this.websockData[index].content.parallaxImage.layers[
                  contentIndex
                ].url = url;
                this.ruleForm.backgroundUrl = url;
                if (this.dataResouceFlag) {
                  this.urlList[index].content.parallax.elements[
                    contentIndex
                  ].url = url;
                } else {
                  this.webpUrlList[index].content.parallax.elements[
                    contentIndex
                  ].url = url;
                }
              }
            }
            return true;
          }
        });
      } else if (type === "重力壁纸资源") {
        this.websockData.some((e, i) => {
          if (e.name === name) {
            var index = i;
            if (key === "imageUrl") {
              if (name === "原始资源") {
                this.websockData[index].staticImage = url;
                this.ruleForm.backgroundUrl = url;
              } else {
                this.websockData[index].content.imageUrl = url;
                this.ruleForm.backgroundUrl = url;
              }
            } else if (key === "thumbUrl") {
              this.websockData[index].thumbUrl = url;
              this.ruleForm.backgroundUrl = url;
            } else if (key === "microThumbShow") {
              if (url1) {
                this.websockData[index].microThumbShow = url1;
                this.websockData[index].microThumb = url;
                this.ruleForm.backgroundUrl = url1;
              } else {
                this.websockData[index].microThumb = url;
                this.ruleForm.backgroundUrl = url;
              }
            } else if (key === "element") {
              if (e.staticImage) {
                this.websockData[index].layers[contentIndex] = url;
                this.ruleForm.backgroundUrl = url;
              } else {
                this.websockData[index].content.gravityImage.elements[
                  contentIndex
                ].url = url;
                this.ruleForm.backgroundUrl = url;
              }
            } else if (key === "backgroundImg") {
              if (e.staticImage) {
                this.websockData[index].backgroundImage = url;
                this.ruleForm.backgroundUrl = url;
              } else {
                this.websockData[index].content.gravityImage.bgUrl = url;
                this.ruleForm.backgroundUrl = url;
              }
            }
            return true;
          }
        });
      } else if (type === "动画壁纸资源") {
        this.websockData.some((e, i) => {
          if (e.name === name) {
            var index = i;
            if (key === "imageUrl") {
              if (name === "原始资源") {
                this.websockData[index].staticImage = url;
                this.ruleForm.backgroundUrl = url;
              } else {
                this.websockData[index].content.imageUrl = url;
                this.ruleForm.backgroundUrl = url;
              }
            } else if (key === "thumbUrl") {
              this.websockData[index].thumbUrl = url;
              this.ruleForm.backgroundUrl = url;
            } else if (key === "microThumbShow") {
              if (url1) {
                this.websockData[index].microThumbShow = url1;
                this.websockData[index].microThumb = url;
                this.ruleForm.backgroundUrl = url1;
              } else {
                this.websockData[index].microThumb = url;
                this.ruleForm.backgroundUrl = url;
              }
            } else if (key === "animation") {
              // if (e.staticImage) {
              //   this.websockData[index].layers[contentIndex] = url
              //   this.ruleForm.backgroundUrl = url
              // } else {
              //   this.websockData[index].content.gravityImage.elements[
              //     contentIndex
              //   ].url = url
              //   this.ruleForm.backgroundUrl = url
              // }
            } else if (key === "images") {
              if (e.staticImage) {
                this.websockData[index].layers[contentIndex] = url;
                this.ruleForm.backgroundUrl = url;
              } else {
                this.websockData[index].images[contentIndex] = url;
                this.ruleForm.backgroundUrl = url;
              }
            }
            return true;
          }
        });
      } else if (type === "壁纸合集资源") {
        this.websockData.some((e, i) => {
          if (e.name === name) {
            var index = i;
            if (key === "imageUrl") {
              if (name === "原始资源") {
                this.websockData[index].staticImage = url;
                this.ruleForm.backgroundUrl = url;
              } else {
                this.websockData[index].content.imageUrl = url;
                this.ruleForm.backgroundUrl = url;
              }
            } else if (key === "thumbUrl") {
              this.websockData[index].thumbUrl = url;
              this.ruleForm.backgroundUrl = url;
            } else if (key === "microThumbShow") {
              if (url1) {
                this.websockData[index].microThumbShow = url1;
                this.websockData[index].microThumb = url;
                this.ruleForm.backgroundUrl = url1;
              } else {
                this.websockData[index].microThumb = url;
                this.ruleForm.backgroundUrl = url;
              }
            } else if (key === "collect") {
              if (e.staticImage) {
                this.websockData[index].image_list[contentIndex] = url;
                this.ruleForm.backgroundUrl = url;
              } else {
                this.websockData[index].content.image_list[contentIndex] = url;
                this.ruleForm.backgroundUrl = url;
              }
            }
            return true;
          }
        });
      }
      if (JSON.parse(resourceType)) {
        this.wallpaperUrlList = this.websockData;
      } else {
        this.wallpaperWebpUrlList = this.websockData;
      }
    },
    //改变展示数据源
    changeDataResouce(flag) {
      this.dataResouceFlag = flag;
      if (flag) {
        this.ruleForm.backgroundUrl = this.wallpaperUrlList[0].content.imageUrl;
        this.websockDataKey = "imageUrl";
        this.activeName = "1080*1920";
        this.websockData = this.wallpaperUrlList;
      } else {
        this.ruleForm.backgroundUrl =
          this.wallpaperWebpUrlList[0].content.imageUrl;
        this.websockDataKey = "imageUrl";
        this.activeName = "1080*1920";
        this.websockData = this.wallpaperWebpUrlList;
      }
    },
    mouseleftFun() {
      if (this.uploadLoading || this.updateLoading) {
        this.maskFlag = true;
      } else {
        this.maskFlag = false;
      }
    },
  },
};
</script>
<style scoped>
.divContainer {
  height: 100%;
}

.fullContainer {
  width: 100%;
  height: 100%;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.main {
  padding: 20px;
}

.card {
  margin-bottom: 20px;
}

.formItemStyle {
  width: 100%;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.smallFont {
  font-size: 12px;
}

.componentItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.resourcesComponent {
  margin-bottom: 10px;
}

.resourcesComponent:last-child {
  margin-bottom: 0;
}

.contentImg {
  height: 350px;
}

.bottomContainer {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  box-shadow: 0px 2px 5px #888;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px;
}

.addIcon {
  font-size: 20px;
  color: greenyellow;
  cursor: pointer;
}

.deleteIcon {
  font-size: 20px;
  color: red;
  cursor: pointer;
}

.updateContainer {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.updateContainer>img {
  /* width: auto;
  height: auto; */
  max-width: 80%;
  max-height: 80%;
}

.updateMask {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.updateButton {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.dataActive {
  color: #569df6;
}

.el-tag {
  margin-right: 10px;
}

.hide {
  display: none;
}

.updateFont {
  width: 80px;
  background-color: #fff;
  text-align: center;
  font-size: 12px;
  border-radius: 5px;
  padding: 5px 10px;
}

.classifyLabel {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100px;
  /* line-height: 10px; */
}

.classifyLabelContainer {
  display: inline-block;
  height: 20px;
  margin-bottom: 10px;
}

.tagContainer {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
}

.tagContainer::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.shaderTitle {
  margin-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .el-input-group__append,
.el-input-group__prepend {
  background-color: #46a0fc;
  color: #ffffff;
  border: 1px solid #46a0fc;
}

::v-deep .el-form-item--mini>.el-form-item__label {
  font-size: 12px;
}

::v-deep .el-dialog__body {
  padding: 10px 20px;
}

::v-deep .el-tag {
  cursor: pointer;
}

::v-deep .el-checkbox__input {
  margin-top: -10px;
}
</style>
